// Local replacement for @codemaniack/form-builder Form component
import React from 'react';
import { Form as BootstrapForm } from 'react-bootstrap';
import FormInput from './FormInput';
import './Form.less';

const Form = ({
  fields = [],
  customClasses = [],
  submit = { allowSubmit: true },
  onSubmit
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit && submit.allowSubmit !== false) {
      onSubmit(e);
    }
  };

  const renderField = (field, index) => {
    // Handle field groups (like the 2-column layout for exp/cvv)
    if (field.group && field.fields) {
      return (
        <div key={`group-${index}`} className={`form-field-group ${field.layout || ''}`}>
          {field.fields.map((subField, subIndex) => renderField(subField, `${index}-${subIndex}`))}
        </div>
      );
    }

    // Regular field - destructure known layout props, pass rest to FormInput
    const { group: _g, layout: _l, fields: _f, helperText: _h, ...fieldProps } = field;
    return (
      <FormInput
        key={field.name || index}
        {...fieldProps}
      />
    );
  };

  return (
    <BootstrapForm 
      onSubmit={handleSubmit}
      className={customClasses.join(' ')}
    >
      {fields.map((field, index) => renderField(field, index))}
    </BootstrapForm>
  );
};

export default Form;
